module.exports = __webpack_public_path__ + "static/media/YF24_2.0c4136ec.jpg";